<template>
    <div id="dev-tools-page">
        <div class="parent">
            <template v-show="isAdmin">
                <div class="c c1-1">
                    <ui5-input
                        type="Text"
                        @keyup.enter="requestClick"
                        :value="controllerInput"
                        @input="controllerInput = $event.target.value"
                        :placeholder="trans('pages.dev_tools.controller_name')"
                    />
                </div>
                <div class="c c1-2">
                    <ui5-input
                        type="Text"
                        @keyup.enter="requestClick"
                        :value="eventInput"
                        @input="eventInput = $event.target.value"
                        :placeholder="trans('pages.dev_tools.event_name')"
                    />
                </div>
                <div class="c c1-3">
                    <ui5-button
                        @click="requestClick"
                        :disabled="validBody.validBody != 'success'"
                    >
                        {{ trans('pages.dev_tools.send_request') }}
                    </ui5-button>
                </div>
            </template>
            <template v-show="isAdmin">
                <div class="c c2-1">
                    <ui5-input
                        type="Text"
                        @keyup.enter="openExportClick"
                        :value="exportInput"
                        @input="exportInput = $event.target.value"
                        :placeholder="trans('pages.dev_tools.export_method')"
                    />
                </div>
                <div class="c c2-2">
                    <ui5-button
                        @click="openExportClick"
                        :disabled="validBody.validBody != 'success'"
                    >
                        {{ trans('pages.dev_tools.open') }}
                    </ui5-button>
                </div>
            </template>
            <template>
                <div class="c c3-1">
                    <ui5-textarea
                        :placeholder="trans('pages.dev_tools.body')"
                        :value="bodyInput"
                        @input="bodyInput = $event.target.value"
                        rows="5"
                    />
                </div>
                <div class="c c3-2">
                    <p
                        v-if="validBody.validBody"
                        :style="{
                            color:
                                validBody.validBody == 'error'
                                    ? 'red'
                                    : 'green',
                        }"
                    >
                        {{ validBody.validBodyText }}
                    </p>
                </div>
            </template>
        </div>

        <p
            id="success"
            v-show="showSuccess"
        >
            {{ trans('pages.dev_tools.success') }}
            <span id="success-message">{{ successMessage }}</span>
        </p>

        <pre
            v-if="formattedData"
            v-html="formattedData"
        />

        <div
            id="error"
            v-if="showError"
        >
            <p>{{ trans('pages.dev_tools.error') }}</p>
            <pre id="error-message">{{ errorMessage }}</pre>
        </div>
    </div>
</template>
<script>
import { syntaxHighlightJSON } from '../helpers/SyntaxHighlightHelpers';
import api from '../api/api';
import axios from 'axios';
import localization from '../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            showSuccess: false,
            successMessage: '',
            showError: false,
            errorMessage: '',
            formattedData: null,

            exportInput: '',
            controllerInput: '',
            eventInput: '',
            bodyInput: '',
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters['currentUser/hasRight'](
                'administration'
            );
        },
        validBody() {
            const validBody = {
                validBody: null,
                validBodyText: '',
            };

            if (!this.bodyInput) {
                validBody.validBody = 'success';
                return validBody;
            }

            let bodyObj = null;
            let err = null;
            try {
                bodyObj = JSON.parse(this.bodyInput);
            } catch (e) {
                err = e;
            }

            if (!err) {
                this.bodyInput = JSON.stringify(bodyObj, undefined, 4);
                validBody.validBody = 'success';
                validBody.validBodyText = this.trans(
                    'pages.dev_tools.valid_json'
                );
            } else {
                validBody.validBody = 'error';
                validBody.validBodyText = err.toString();
            }

            return validBody;
        },
    },
    mounted() {
        const devBody = '';

        if (!devBody || devBody.length == 0) {
            var defaultBody = JSON.parse('{ "key": "value" }');
            this.bodyInput = JSON.stringify(defaultBody, undefined, 4);
        }
    },
    methods: {
        requestClick() {
            this.showSuccess = false;
            this.showError = false;
            this.formattedData = null;

            const payload = JSON.parse(this.bodyInput);
            axios
                .post(
                    '/' + this.controllerInput + '/' + this.eventInput + '/',
                    payload
                )
                .then((response) => {
                    this.successMessage = response.data.result;
                    this.formattedData = syntaxHighlightJSON(
                        JSON.stringify(response.data.data, undefined, 4)
                    );
                    this.showSuccess = true;
                })
                .catch((err) => {
                    this.errorMessage = err.response;
                    this.showError = true;
                });
        },
        openExportClick() {
            window.open(
                api.createGetUrl(this.exportInput, JSON.parse(this.bodyInput))
            );
        },
    },
};
</script>
